import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import LocatorHelper from '@/Utility/LocatorHelper';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import SearchDescriptionViewModel from '@/ViewModels/Controls/SearchDescriptionViewModel';
import SearchDescription from '../../Controls/SearchDescription';

export default class SearchDescriptionFactory extends ControlFactory {

    private jQueryControl: JQuery;
    private SearchDescriptionViewModel = ComponentManager.getViewModel<typeof SearchDescriptionViewModel>('SearchDescriptionViewModel');
    private SearchDescription = ComponentManager.getControl<typeof SearchDescription>('SearchDescription');
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');

    public viewModel: SearchDescriptionViewModel;

    public constructor(private params: any) {
        super(params);
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) return this.jQueryControl;

        this.viewModel = this.createViewModel();
        this.control = this.createControl();


        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        return this.jQueryControl;
    }

    private createViewModel(): SearchDescriptionViewModel {
        return new this.SearchDescriptionViewModel({
            locator: LocatorHelper.buildLocator(this.locator, 'search-description'),
            isVisible: this.defineComputed(() => {
                let searchKeyword = ko.unwrap(this.params.searchKeyword);
                let hovered = ko.unwrap(this.params.hovered);

                return !!searchKeyword && !!hovered;
            }),
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            }),
            //Wir steuern das Anzeigen des Tooltips selbst,
            //um eine feste Wartezeit per showAfter zu vermeiden
            isAutoHide: false,
            isShownOnClick: false,
            isShownOnHover: false,
            showAfter: 0,
            filter: '.GridBodyTable td',
            content: this.observableOrDefault(''),
            hovered: this.params.hovered,
            searchKeyword: this.params.searchKeyword
        });
    }

    private createControl(): SearchDescription {
        return new this.SearchDescription(this.viewModel);
    }
}

ComponentManager.setFactory('SearchDescription', SearchDescriptionFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');